import { AspectRatio } from "@/types";

import { Area, Size } from "../../../types";

export const getCenteredArea = (
  aspectRatio: AspectRatio,
  stageSize: Size,
  margin = 40,
): Area => {
  const availableWidth = stageSize.width - margin * 2;
  const availableHeight = stageSize.height - margin * 2;

  const aspectRatioValue = aspectRatio.width / aspectRatio.height;
  const availableAspectRatio = availableWidth / availableHeight;

  let clearWidth: number;
  let clearHeight: number;

  if (aspectRatioValue > availableAspectRatio) {
    // Aspect ratio is wider than available space - fit to width
    clearWidth = availableWidth;
    clearHeight = availableWidth / aspectRatioValue;
  } else {
    // Aspect ratio is taller than available space - fit to height
    clearHeight = availableHeight;
    clearWidth = availableHeight * aspectRatioValue;
  }

  return {
    x: (stageSize.width - clearWidth) / 2,
    y: (stageSize.height - clearHeight) / 2,
    width: clearWidth,
    height: clearHeight,
  };
};
